import { Alert, Box, Button, Heading, Text, VStack } from 'native-base'
import { useEffect, useRef, useState } from 'react'
import { useAuthContext } from '../../providers/AuthProvider'
import FormInput from '../_shared/form/FormInput'

const PasswordLogin = ({ email, onResetPassword }) => {
  const [password, setPassword] = useState('')
  const [isValid, setValid] = useState(false)
  const [isError, setError] = useState(false)
  const [isWaiting, setWaiting] = useState(false)
  const focusedInput = useRef(0)
  const { loginWithEmailPassword } = useAuthContext()

  const login = () => {
    setWaiting(true)
    setError(false)
    loginWithEmailPassword(email, password)
      .catch((error) => {
        setError(true)
      })
      .finally(() => setWaiting(false))
  }

  useEffect(() => {
    setValid(!!password)
  }, [password])

  return (
    <VStack h="100%" w="100%" style={{ gap: 12 }}>
      <Heading fontSize={'2xl'} mt="3" color="primary.900">
        Enter your password
      </Heading>
      <Box mb={-6}>
        <FormInput
          testID="password-input"
          bg="white"
          autofocus
          defaultValue={password}
          type="password"
          label="Password"
          onChangeText={setPassword}
          inputAccessoryViewID={'form'}
          onFocusCallback={() => {
            focusedInput.current = 0
          }}
        />
      </Box>
      {isError && (
        <Alert colorScheme="error" variant="subtle" mt={-4}>
          <Text w="100%" color="text.900">
            This email and password combination is not valid. Try another login
            method or&nbsp;
            <Text underline onPress={() => onResetPassword()}>
              reset your password
            </Text>
            .
          </Text>
        </Alert>
      )}
      <Button
        isLoading={isWaiting}
        testID="continue-log-in-button"
        onPress={login}
        isDisabled={!isValid}>
        Continue
      </Button>
    </VStack>
  )
}

export default PasswordLogin
